export default "__VITE_ASSET__362b126f__"